// Section 13 (Tanulmányi Körülmények) Options Definitions

// 13.1 A képzés tanulmányi körülményei
export const SZAKMENTON_RENDSZER_OPTIONS = {
    hu: [
        { value: 'megfelelo', label: 'Megfelelő' },
        { value: 'reszben_megfelelo', label: 'Részben megfelelő' },
        { value: 'nem_megfelelo_javitando', label: 'Nem megfelelő, javítandó' },
        { value: 'nem_relevans', label: 'Nem releváns' }
    ],
    en: [
        { value: 'megfelelo', label: 'Appropriate' },
        { value: 'reszben_megfelelo', label: 'Partially appropriate' },
        { value: 'nem_megfelelo_javitando', label: 'Inadequate, requires improvement' },
        { value: 'nem_relevans', label: 'Not relevant' }
    ]
};

// Tanulmányi táblázatok (mintatanterv, követelményék)
export const TANULMANYI_TABLAZATOK_OPTIONS = {
    hu: [
        { value: 'megfelelo', label: 'Megfelelő' },
        { value: 'reszben_megfelelo', label: 'Részben megfelelő' },
        { value: 'nem_megfelelo_javitando', label: 'Nem megfelelő, javítandó' },
        { value: 'nem_relevans', label: 'Nem releváns' }
    ],
    en: [
        { value: 'megfelelo', label: 'Appropriate' },
        { value: 'reszben_megfelelo', label: 'Partially appropriate' },
        { value: 'nem_megfelelo_javitando', label: 'Inadequate, requires improvement' },
        { value: 'nem_relevans', label: 'Not relevant' }
    ]
};

// Oktatói konzultáció lehetőségek elérhetősége
export const OKTATOI_KONZULTACIO_OPTIONS = {
    hu: [
        { value: 'megfelelo', label: 'Megfelelő' },
        { value: 'reszben_megfelelo', label: 'Részben megfelelő' },
        { value: 'nem_megfelelo_javitando', label: 'Nem megfelelő, javítandó' },
        { value: 'nem_relevans', label: 'Nem releváns' }
    ],
    en: [
        { value: 'megfelelo', label: 'Appropriate' },
        { value: 'reszben_megfelelo', label: 'Partially appropriate' },
        { value: 'nem_megfelelo_javitando', label: 'Inadequate, requires improvement' },
        { value: 'nem_relevans', label: 'Not relevant' }
    ]
};

// Felzárkóztató képzések
export const FELZARKOZTATO_KEPZESEK_OPTIONS = {
    hu: [
        { value: 'megfelelo', label: 'Megfelelő' },
        { value: 'reszben_megfelelo', label: 'Részben megfelelő' },
        { value: 'nem_megfelelo_javitando', label: 'Nem megfelelő, javítandó' },
        { value: 'nem_relevans', label: 'Nem releváns' }
    ],
    en: [
        { value: 'megfelelo', label: 'Appropriate' },
        { value: 'reszben_megfelelo', label: 'Partially appropriate' },
        { value: 'nem_megfelelo_javitando', label: 'Inadequate, requires improvement' },
        { value: 'nem_relevans', label: 'Not relevant' }
    ]
};

// Tehetséggondozási lehetőségek
export const TEHETSEGGONDOZASI_LEHETOSEGEK_OPTIONS = {
    hu: [
        { value: 'megfelelo', label: 'Megfelelő' },
        { value: 'reszben_megfelelo', label: 'Részben megfelelő' },
        { value: 'nem_megfelelo_javitando', label: 'Nem megfelelő, javítandó' },
        { value: 'nem_relevans', label: 'Nem releváns' }
    ],
    en: [
        { value: 'megfelelo', label: 'Appropriate' },
        { value: 'reszben_megfelelo', label: 'Partially appropriate' },
        { value: 'nem_megfelelo_javitando', label: 'Inadequate, requires improvement' },
        { value: 'nem_relevans', label: 'Not relevant' }
    ]
};

// Szakmai gyakorlat támogatása
export const SZAKMAI_GYAKORLAT_OPTIONS = {
    hu: [
        { value: 'megfelelo', label: 'Megfelelő' },
        { value: 'reszben_megfelelo', label: 'Részben megfelelő' },
        { value: 'nem_megfelelo_javitando', label: 'Nem megfelelő, javítandó' },
        { value: 'nem_relevans', label: 'Nem releváns' }
    ],
    en: [
        { value: 'megfelelo', label: 'Appropriate' },
        { value: 'reszben_megfelelo', label: 'Partially appropriate' },
        { value: 'nem_megfelelo_javitando', label: 'Inadequate, requires improvement' },
        { value: 'nem_relevans', label: 'Not relevant' }
    ]
};

// Oktatási segédanyagok fejlesztése
export const OKTATASI_SEGEDANYAGOK_OPTIONS = {
    hu: [
        { value: 'megfelelo', label: 'Megfelelő' },
        { value: 'reszben_megfelelo', label: 'Részben megfelelő' },
        { value: 'nem_megfelelo_javitando', label: 'Nem megfelelő, javítandó' },
        { value: 'nem_relevans', label: 'Nem releváns' }
    ],
    en: [
        { value: 'megfelelo', label: 'Appropriate' },
        { value: 'reszben_megfelelo', label: 'Partially appropriate' },
        { value: 'nem_megfelelo_javitando', label: 'Inadequate, requires improvement' },
        { value: 'nem_relevans', label: 'Not relevant' }
    ]
};

// Digitális tananyagok (LMS, e-learning)
export const DIGITALIS_TANANYAGOK_OPTIONS = {
    hu: [
        { value: 'megfelelo', label: 'Megfelelő' },
        { value: 'reszben_megfelelo', label: 'Részben megfelelő' },
        { value: 'nem_megfelelo_javitando', label: 'Nem megfelelő, javítandó' },
        { value: 'nem_relevans', label: 'Nem releváns' }
    ],
    en: [
        { value: 'megfelelo', label: 'Appropriate' },
        { value: 'reszben_megfelelo', label: 'Partially appropriate' },
        { value: 'nem_megfelelo_javitando', label: 'Inadequate, requires improvement' },
        { value: 'nem_relevans', label: 'Not relevant' }
    ]
};

// Digitális eszközök/szoftverek rendelkezésre állása
export const DIGITALIS_ESZKOZOK_OPTIONS = {
    hu: [
        { value: 'megfelelo', label: 'Megfelelő' },
        { value: 'reszben_megfelelo', label: 'Részben megfelelő' },
        { value: 'nem_megfelelo_javitando', label: 'Nem megfelelő, javítandó' },
        { value: 'nem_relevans', label: 'Nem releváns' }
    ],
    en: [
        { value: 'megfelelo', label: 'Appropriate' },
        { value: 'reszben_megfelelo', label: 'Partially appropriate' },
        { value: 'nem_megfelelo_javitando', label: 'Inadequate, requires improvement' },
        { value: 'nem_relevans', label: 'Not relevant' }
    ]
};
